var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "45px",
    height: "38px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(107, 238, 241)",
    d: "M0.753,20.445 L10.029,0.196 L18.979,0.196 L13.121,18.785 L18.979,18.785 L18.979,37.374 L0.753,37.374 L0.753,20.445 ZM26.789,20.445 L36.064,0.196 L45.015,0.196 L39.156,18.785 L45.015,18.785 L45.015,37.374 L26.789,37.374 L26.789,20.445 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.f51b01f3f3a33e840421fcc5d03a7585.svg";
export { ForwardRef as ReactComponent };